import React from "react";
import styled from "styled-components";

const Wrapper = styled.svg`
  width: auto;
  height: 2.625rem;
  margin-top: 0.125rem;
`;
export default function Bricolage() {
  return (
    <Wrapper
      width="530"
      height="512"
      viewBox="0 0 530 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M62.0519 512C7.14296 512.069 -20.8111 444.941 18.1707 406.06C18.1696 406.06 155.046 269.183 155.046 269.183C186.803 238.153 198.736 194.12 194.385 150.252C194.386 88.3919 227.881 31.7846 281.8 2.52532C295.299 -4.99611 312.538 5.23002 312.353 20.7063V121.033C312.353 132.44 321.632 141.719 333.039 141.719H393.028C404.434 141.719 413.714 132.44 413.714 121.033V20.7063C413.714 13.3389 417.632 6.52807 424 2.82424C430.37 -0.880626 438.227 -0.914759 444.63 2.72701C497.301 32.1498 531.187 92.8404 529.528 153.338C528.024 180.758 488.621 179.942 488.162 152.592C488.755 119.674 476.395 87.6989 455.086 63.7952V121.033C455.086 155.252 427.247 183.091 393.028 183.091H333.039C298.82 183.091 270.981 155.252 270.981 121.033V62.19C248.708 85.3997 235.759 116.799 235.759 150.253C240.85 205.032 223.466 259.813 184.3 298.439C184.301 298.439 47.4248 435.314 47.4248 435.314C39.3583 443.38 39.3583 456.502 47.4248 464.568C55.4893 472.634 68.6135 472.634 76.678 464.568L213.441 327.806C250.214 291.034 300.84 272.126 352.312 275.902C363.706 276.741 372.262 286.656 371.425 298.05C370.587 309.445 360.661 317.99 349.277 317.163C309.805 314.26 270.954 328.801 242.696 357.06L105.933 493.822C94.2124 505.544 78.6286 512 62.0519 512ZM437.46 299.84C466.032 285.527 489.762 263.482 506.085 236.087C511.932 226.272 508.718 213.575 498.903 207.727C489.092 201.882 476.393 205.095 470.544 214.91C458.274 235.504 440.426 252.08 418.93 262.849C394.835 276.202 412.518 311.142 437.46 299.84Z"
        className="fill"
      />
    </Wrapper>
  );
}
